import { combineReducers } from 'redux';

import * as types from 'modules/campaignFiles/actionTypes';
import { DRAWER_DETAILS_TARGET } from 'modules/campaignFiles/constants';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   open: boolean,
 *   loading: string[],
 *   campaignFileId: string
 * }} CampaignFilesUIDetailsReducer
 */

const detailsDrawerMatcher = ({ meta }) => meta?.source === DRAWER_DETAILS_TARGET;

const GENERIC_SLICE_CONFIG = ({
  global: {
    selectId: entity => entity?.campaignFileId ?? entity?.id,
    matcher: detailsDrawerMatcher
  },
});

export default combineReducers({
  loading: loadingArraySlice(types.FETCH_CAMPAIGN_FILE, GENERIC_SLICE_CONFIG),
  open: createReducer(false, {
    [types.FETCH_CAMPAIGN_FILE_SUCCESS]: (_, { meta }) => meta?.source === DRAWER_DETAILS_TARGET,
    [types.CLOSE_DETAILS_DRAWER]: () => false,
    [LOCATION_CHANGE]: () => false,
  }),
  campaignFileId: createReducer(null, {
    [types.OPEN_DETAILS_DRAWER]: (_, { payload: campaignFileId }) => campaignFileId,
  }),
});
